<script>
import { Line } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { mapGetters } from 'vuex'

export default {
  extends: Line,
  props: {
    deviceUsage: Array,
    labels: Array
  },
  computed: {
    ...mapGetters({
      numDates: 'numDates',
      startDate: 'startDate',
      endDate: 'endDate'
    })
  },
  watch: {
    /**
     * Executes loadChart function when the deviceUsage prop is updated.
     */
    deviceUsage () {
      this.loadChart()
    }
  },
  methods: {
    /**
     * Renders line chart using the chart.js library.
     */
    loadChart () {
      const brandInfo = getStyle('--info') || '#20a8d8'

      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: 'Device Usage Data',
            backgroundColor: hexToRgba(brandInfo, 10),
            borderColor: brandInfo,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: this.deviceUsage
          }
        ]
      }, {
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              maxTicksLimit: 10
            },
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5
              // stepSize: Math.ceil(250 / 5),
              // max: 2
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      })
    }
  }
}
</script>
